import React, { useState } from "react";
import { HiOutlineX } from "react-icons/hi";
import questionFormats from "../../utils/questionFormats.json";

const Tests = () => {
  const [selectedType, setSelectedType] = useState(null);
  const [selectedTest, setSelectedTest] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleTypeClick = (type) => {
    setSelectedType(type);
    setSelectedTest(null);
  };

  const handleTestClick = (test) => {
    setSelectedTest(test);
    setModalOpen(true);
  };

  const renderQuestion = (q, index) => {
    if (q.options) {
      // Choice or True/False
      return (
        <ul className="space-y-2">
          {q.options.map((option, i) => (
            <li key={i} className="flex items-center">
              <input
                type="radio"
                name={`question-${index}`}
                id={`option-${index}-${i}`}
                className="mr-2"
              />
              <label htmlFor={`option-${index}-${i}`}>{option}</label>
            </li>
          ))}
        </ul>
      );
    } else if (q.answer && typeof q.answer === "string") {
      // Short Answer
      return (
        <textarea
          className="w-full p-2 border rounded-md"
          rows="3"
          placeholder="Write your answer here..."
        />
      );
    } else if (q.pairs) {
      // Matching
      return (
        <div className="space-y-2">
          {q.pairs.map((pair, i) => (
            <div key={i} className="flex items-center">
              <span className="flex-1">{pair.term}</span>
              <input
                type="text"
                maxLength="1"
                className="w-12 p-1 border rounded text-center mx-2"
                placeholder="_"
              />
              <span className="flex-1 text-right">{pair.match}</span>
            </div>
          ))}
        </div>
      );
    }
  };

  return (
    <div className="">
      <h1 className="text-2xl font-bold text-center mb-6">Tests</h1>
      {/* Horizontal Tabs */}
      <div className="flex gap-4 overflow-x-auto pb-4">
        {questionFormats.map((format) => (
          <button
            key={format.type}
            className={`py-2 px-4 rounded-lg shadow ${
              selectedType === format.type
                ? "bg-blue-600 text-white"
                : "bg-gray-200 text-gray-800"
            } hover:bg-blue-500 hover:text-white`}
            onClick={() => handleTypeClick(format.type)}
          >
            {format.type}
          </button>
        ))}
      </div>

      {/* Tests List */}
      <div className="mt-4">
        {selectedType && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {questionFormats
              .find((format) => format.type === selectedType)
              ?.tests.map((test) => (
                <div
                  key={test.title}
                  className="p-4 border rounded-lg shadow hover:shadow-lg cursor-pointer"
                  onClick={() => handleTestClick(test)}
                >
                  <h2 className="text-lg font-semibold">{test.title}</h2>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* Modal */}
      {modalOpen && selectedTest && (
        <div className="absolute z-50 inset-0 bg-opacity-50 flex items-center justify-center bg-transparent backdrop-blur-lg">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full relative">
            <button
              className="absolute top-2 right-2 text-blue-500 hover:text-blue-700"
              onClick={() => setModalOpen(false)}
            >
              <HiOutlineX size={30} />
            </button>
            <h3 className="text-xl font-bold mb-4">{selectedTest.title}</h3>
            <div className="space-y-4">
              {selectedTest.questions.map((q, index) => (
                <div key={index} className="mb-4">
                  <p className="mb-2 font-medium">{q.question}</p>
                  {renderQuestion(q, index)}
                </div>
              ))}
              <div className="text-right">
                <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tests;
